// Access token in memory; refresh token in an httpOnly cookie (server-managed).

import { decodeJwt } from "jose";

type TokenMeta = { token: string; exp: number };

let _access: TokenMeta | null = null;

export const tokenStorage = {
  setAccess(token: string) {
    // Decode exp once and cache it — avoid re-decoding on every request
    try {
      const { exp } = decodeJwt(token);
      _access = { token, exp: exp ?? 0 };
    } catch {
      _access = { token, exp: 0 };
    }
  },

  getAccess(): string | null {
    return _access?.token ?? null;
  },

  getAccessExp(): number {
    return _access?.exp ?? 0;
  },

  clearAccess() {
    _access = null;
  },

  clear() {
    this.clearAccess();
  },
};
